import React, { useState } from "react";
import "./View_Sankalp_Note_Modal.css";
import { Modal, Form } from "react-bootstrap";
import Light_Black_Btn from "../../common/common_btn/light_black_btn/Light_Black_Btn";
import { formatDate } from "../../../utils/common";




const View_Sankalp_Note_Modal = ({ modalTitle,selectedNote, ...props }) => {

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Sankalp_Note_Modal Sankalp_Notes_Modal"
      >
        <Modal.Body>
          <form >
            <div className="content_div">
              {/* <p className="label_text">{modalTitle}</p> */}

                <div className="desc_div">
                    <div className="title_div">
                        <p className="title_text">{selectedNote?.name}</p>
                        <p className="date_text">{formatDate(selectedNote?.createdAt)}</p>
                    </div>
                    <p className="descn">{selectedNote?.description}</p>
                </div>
        
              <div className="btn_holder">
                <Light_Black_Btn
                  btnText={"Close"}
                  onClick={() => props?.onHide()}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

     
    </>
  );
};

export default View_Sankalp_Note_Modal;
